import {useLayoutEffect} from 'react';

/** Theme the page canvas as well as its contents, including mobile overscroll. */
export function usePageTheme(dark: boolean): void {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const theme = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const scheme = document.querySelector<HTMLMetaElement>('meta[name="color-scheme"]');
    const previous = {theme: root.dataset.pageTheme, color: theme?.content, scheme: scheme?.content};
    root.dataset.pageTheme = dark ? 'dark' : 'light';
    if (theme) theme.content = dark ? '#000000' : '#ffffff';
    if (scheme) scheme.content = dark ? 'dark' : 'light';
    return () => {
      if (previous.theme === undefined) delete root.dataset.pageTheme;
      else root.dataset.pageTheme = previous.theme;
      if (theme && previous.color !== undefined) theme.content = previous.color;
      if (scheme && previous.scheme !== undefined) scheme.content = previous.scheme;
    };
  }, [dark]);
}
